import { useTypedFlags } from "@hooks/useTypedFlags";

export function useCanShowBillInvoiceInbox(): boolean {
    const { billInvoiceImporter } = useTypedFlags();
    return billInvoiceImporter;
}

export function useDocumentInboxSettingsLabel(): string {
    const canShowBillInvoiceInbox = useCanShowBillInvoiceInbox();
    return canShowBillInvoiceInbox ? "Document inbox" : "Receipts";
}
